<template>
    <app-sercheable-data-table
        :headers="headers"
        :search="search"
        :refresh="refresh"
        :pagination="pagination"
    >
        <template slot="items" slot-scope="{ item }">
            <router-link
                :to="{ name: 'personEdit', params: { id: item.id } }"
                tag="tr"
            >
                <td class="area-name">{{ item.area | areaToString }}</td>
                <td class="person-username">{{ item.username }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.emailAddress }}</td>
                <td class="is-active">{{ item.status }}</td>
            </router-link>
        </template>
    </app-sercheable-data-table>
</template>

<script>
import utilities from "@/helpers/utilities";
import SercheableDataTable from "../shared/SercheableDataTable";

export default {
    data() {
        return {
            pagination: {
                descending: false,
                sortBy: "name"
            },
            headers: [
                {
                    text: this.$t("label.area"),
                    value: "area.acronym",
                    align: "left"
                },
                {
                    text: this.$t("label.code"),
                    value: "username",
                    align: "left"
                },
                {
                    text: this.$t("label.name"),
                    value: "name",
                    align: "left"
                },
                {
                    text: this.$t("label.email"),
                    value: "emailAddress",
                    align: "left",
                    sortable: false
                },
                {
                    text: `${this.$t("label.active")}?`,
                    value: "status",
                    align: "left"
                }
            ]
        };
    },
    computed: {
        persons() {
            const persons = this.$store.getters.persons.filter(person => {
                if (!this.$store.getters.profile.office) return person;
                return (
                    !!person.area &&
                    person.office.id === this.$store.getters.profile.office
                );
            });
            persons.forEach(person => {
                person.status = person.isActive
                    ? this.$t("label.yes")
                    : this.$t("label.no");
            });
            return persons;
        },
        readonly() {
            return !this.$store.getters.isAdmin;
        }
    },

    methods: {
        search(filters) {
            // const persons = this.$store.getters.persons;

            return utilities.filterMultiple(
                this.persons,
                filters,
                (person, regex) =>
                    regex.test(person.username) ||
                    regex.test(person.name) ||
                    regex.test((person.area || {}).acronym) ||
                    regex.test(person.emailAddress || regex.test(person.status))
            );
        },
        async refresh() {
            await this.$store.dispatch("loadPersons");
        }
    },
    components: {
        appSercheableDataTable: SercheableDataTable
    }
};
</script>



// WEBPACK FOOTER //
// src/components/persons/Index.vue